import classNames from 'classnames';
import { SVGPropsIcon } from 'src/types';
import { twJoin } from 'tailwind-merge';

export const SimpleClose = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      onClick={props.onShow}
      className={classNames('cursor-pointer', props.className)}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.96 12.0008L23.3847 4.57604C24.2051 3.75569 24.2051 2.42569 23.3847 1.60661L22.3949 0.616805C21.5743 -0.203807 20.2443 -0.203807 19.4252 0.616805L12.0008 8.04127L4.57604 0.615266C3.75569 -0.205089 2.42569 -0.205089 1.60661 0.615266L0.615266 1.60508C-0.205089 2.42569 -0.205089 3.75569 0.615266 4.57476L8.04127 12.0008L0.616805 19.4252C-0.203807 20.2459 -0.203807 21.5759 0.616805 22.3949L1.60661 23.3847C2.42697 24.2051 3.75697 24.2051 4.57604 23.3847L12.0008 15.96L19.4252 23.3847C20.2459 24.2051 21.5759 24.2051 22.3949 23.3847L23.3847 22.3949C24.2051 21.5743 24.2051 20.2443 23.3847 19.4252L15.96 12.0008Z"
        fill={props.fill ? props.fill : 'var(--wdap_icon_cross)'}
      />
    </svg>
  );
};

export const CloseComponentWithoutStyles = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      onClick={props.onShow}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1417 8.00048L14.7822 3.36003C15.2949 2.84731 15.2949 2.01605 14.7822 1.50413L14.1635 0.885503C13.6507 0.372621 12.8194 0.372621 12.3075 0.885503L7.6672 5.5258L3.02674 0.884541C2.51402 0.37182 1.68277 0.37182 1.17085 0.884541L0.551259 1.50317C0.038537 2.01605 0.038537 2.84731 0.551259 3.35923L5.19251 8.00048L0.55222 12.6408C0.0393382 13.1537 0.0393382 13.9849 0.55222 14.4968L1.17085 15.1155C1.68357 15.6282 2.51482 15.6282 3.02674 15.1155L7.6672 10.475L12.3075 15.1155C12.8204 15.6282 13.6516 15.6282 14.1635 15.1155L14.7822 14.4968C15.2949 13.9839 15.2949 13.1527 14.7822 12.6408L10.1417 8.00048Z"
        fill="white"
      />
    </svg>
  );
};

export const CloseSearchTopbar = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="26"
      className="self-end min-h-[30px] max-h-[30px] min-w-[30px] max-w-[30px] m-[14px] stroke-[5px] cursor-pointer ease-in duration-300"
      onClick={props.closeTopDrawer}
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.65 13.0003L17.7436 9.90668C18.0855 9.56487 18.0855 9.0107 17.7436 8.66942L17.3312 8.257C16.9893 7.91508 16.4351 7.91508 16.0939 8.257L13.0003 11.3505L9.90668 8.25636C9.56487 7.91455 9.0107 7.91455 8.66942 8.25636L8.25636 8.66878C7.91455 9.0107 7.91455 9.56487 8.25636 9.90615L11.3505 13.0003L8.257 16.0939C7.91508 16.4358 7.91508 16.9899 8.257 17.3312L8.66942 17.7436C9.01124 18.0855 9.5654 18.0855 9.90668 17.7436L13.0003 14.65L16.0939 17.7436C16.4358 18.0855 16.9899 18.0855 17.3312 17.7436L17.7436 17.3312C18.0855 16.9893 18.0855 16.4351 17.7436 16.0939L14.65 13.0003Z"
        fill="white"
      />
    </svg>
  );
};

export const BigCloseGame = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 48 48"
      fill="none"
      onClick={props.onShow}
      className={classNames('cursor-pointer', props.className)}>
      <path
        d="M8 8L40 40M8 8L40 40M8 8L40 40"
        stroke="var(--sgp_burger)"
        strokeWidth="3.75"
        strokeLinecap="round"
      />
      <path
        d="M40 8L8 40M40 8L8 40M40 8L8 40"
        stroke="var(--sgp_burger)"
        strokeWidth="3.75"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ThinClose = ({
  onClick,
  className
}: {
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  className?: string;
}) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className={twJoin('cursor-pointer', className)}
      fill="none">
      <rect
        x="2.10938"
        y="1.90039"
        width="12"
        height="1.00001"
        transform="rotate(45 2.10938 1.90039)"
        fill="white"
      />
      <rect
        x="1.40039"
        y="10.3896"
        width="12"
        height="1.00001"
        transform="rotate(-45 1.40039 10.3896)"
        fill="white"
      />
    </svg>
  );
};
